/**
 * @flow
 * @relayHash cf3e08381f65afbedf6b279a58c278c6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type publishHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  publishDate: string,
  publish?: ?string,
|};
export type publishEventMutationVariables = {|
  input: publishHyeventInput
|};
export type publishEventMutationResponse = {|
  +publishHyevent: ?{|
    +hyevent: ?{|
      +additionalGuestAllowed: boolean,
      +id: string,
      +status: string,
      +title: string,
      +publishAt: ?any,
      +campaignTested: ?boolean,
    |}
  |}
|};
export type publishEventMutation = {|
  variables: publishEventMutationVariables,
  response: publishEventMutationResponse,
|};
*/


/*
mutation publishEventMutation(
  $input: publishHyeventInput!
) {
  publishHyevent(input: $input) {
    hyevent {
      additionalGuestAllowed
      id
      status
      title
      publishAt
      campaignTested
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "publishHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "publishHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "publishHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "campaignTested",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "publishEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "publishEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "publishEventMutation",
    "id": null,
    "text": "mutation publishEventMutation(\n  $input: publishHyeventInput!\n) {\n  publishHyevent(input: $input) {\n    hyevent {\n      additionalGuestAllowed\n      id\n      status\n      title\n      publishAt\n      campaignTested\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6311d8354230dfb603a43a86c8f2b010';
module.exports = node;
